<template>
  <b-row class="mc-report__route-geolocation-value">
    <b-col md="6">
      <div class="mc-report__route-geolocation-value-item">
        <span>{{ $t('report.fields.averageMileage') }}</span>
        <br />
        <h5>
          {{ parseFloat((tripsBetweenGeofences.avg.mileage / 1000).toFixed(2)) ?? '0' }}
          <strong>Km</strong>
        </h5>
        <McBadge
          variant="outlineDanger"
          type="button"
          :text="tripsBetweenGeofences.anomaly.mileage + $t('report.text.anomalyData')"
          v-if="tripsBetweenGeofences.anomaly.mileage"
        />
      </div>
    </b-col>
    <b-col md="6">
      <div class="mc-report__route-geolocation-value-item">
        <span>{{ $t('report.fields.averageTripFuel') }}</span>
        <br />
        <h5>
          {{ parseFloat(tripsBetweenGeofences.avg.tripFuel.toFixed(2)) ?? '0' }} <strong>L</strong>
        </h5>
        <McBadge
          variant="outlineDanger"
          type="button"
          :text="tripsBetweenGeofences.anomaly.tripFuel + $t('report.text.anomalyData')"
          v-if="tripsBetweenGeofences.anomaly.tripFuel"
        />
      </div>
    </b-col>
    <b-col md="6">
      <div class="mc-report__route-geolocation-value-item">
        <span>{{ $t('report.fields.averageFuelEfficiency') }}</span>
        <br />
        <h5>
          {{ parseFloat(tripsBetweenGeofences.avg.fuelEfficiency).toFixed(2) ?? '0' }}
          <strong>Km/L</strong>
        </h5>
        <McBadge
          variant="outlineDanger"
          type="button"
          :text="tripsBetweenGeofences.anomaly.fuelEfficiency + $t('report.text.anomalyData')"
          v-if="tripsBetweenGeofences.anomaly.fuelEfficiency"
        />
      </div>
    </b-col>
    <b-col md="6">
      <div class="mc-report__route-geolocation-value-item">
        <span>{{ $t('report.fields.averageMoveDuration') }}</span>
        <br />
        <h5>
          {{
            tripsBetweenGeofences.avg.moveDuration > 0
              ? Math.floor(tripsBetweenGeofences.avg.moveDuration / 3600)
              : Math.ceil(tripsBetweenGeofences.avg.moveDuration / 3600)
          }}
        </h5>
        <strong>{{ $t('global.time.hour') }}</strong>
        <h5>
          {{ Math.floor(Math.abs(Math.round(tripsBetweenGeofences.avg.moveDuration % 3600) / 60)) }}
        </h5>
        <strong>{{ $t('global.time.minutes') }}</strong>
        <h5>
          {{ Math.abs(Math.round(tripsBetweenGeofences.avg.moveDuration % 3600) % 60) }}
        </h5>
        <strong>{{ $t('global.time.seconds') }}</strong>
        <McBadge
          variant="outlineDanger"
          type="button"
          :text="tripsBetweenGeofences.anomaly.moveDuration + $t('report.text.anomalyData')"
          v-if="tripsBetweenGeofences.anomaly.moveDuration"
        />
      </div>
    </b-col>
    <b-col md="6">
      <div class="mc-report__route-geolocation-value-item">
        <span>{{ $t('report.fields.averageIdleDuration') }}</span>
        <br />
        <div class="mc-report__route-geolocation-data">
          <h5>
            {{
              tripsBetweenGeofences.avg.idleDuration > 0
                ? Math.floor(tripsBetweenGeofences.avg.idleDuration / 3600)
                : Math.ceil(tripsBetweenGeofences.avg.idleDuration / 3600)
            }}
          </h5>
          <strong>{{ $t('global.time.hour') }}</strong>
          <h5>
            {{
              Math.floor(Math.abs(Math.round(tripsBetweenGeofences.avg.idleDuration % 3600) / 60))
            }}
          </h5>
          <strong>{{ $t('global.time.minutes') }}</strong>
          <h5>
            {{ Math.abs(Math.round(tripsBetweenGeofences.avg.idleDuration % 3600) % 60) }}
          </h5>
          <strong>{{ $t('global.time.seconds') }}</strong>
          <McBadge
            variant="outlineDanger"
            type="button"
            :text="tripsBetweenGeofences.anomaly.idleDuration + $t('report.text.anomalyData')"
            v-if="tripsBetweenGeofences.anomaly.idleDuration"
          />
        </div>
      </div>
    </b-col>
    <b-col md="6">
      <div class="mc-report__route-geolocation-value-item">
        <span>{{ $t('report.fields.averageStopDuration') }}</span>
        <br />
        <h5>
          {{
            tripsBetweenGeofences.avg.stopDuration > 0
              ? Math.floor(tripsBetweenGeofences.avg.stopDuration / 3600)
              : Math.ceil(tripsBetweenGeofences.avg.stopDuration / 3600)
          }}
        </h5>
        <strong>{{ $t('global.time.hour') }}</strong>
        <h5>
          {{ Math.floor(Math.abs(Math.round(tripsBetweenGeofences.avg.stopDuration % 3600) / 60)) }}
        </h5>
        <strong>{{ $t('global.time.minutes') }}</strong>
        <h5>
          {{ Math.abs(Math.round(tripsBetweenGeofences.avg.stopDuration % 3600) % 60) }}
        </h5>
        <strong>{{ $t('global.time.seconds') }}</strong>
        <McBadge
          variant="outlineDanger"
          type="button"
          :text="tripsBetweenGeofences.anomaly.stopDuration + $t('report.text.anomalyData')"
          v-if="tripsBetweenGeofences.anomaly.stopDuration"
        />
      </div>
    </b-col>
    <b-col md="6">
      <div class="mc-report__route-geolocation-value-item">
        <span>{{ $t('report.fields.averageTripDuration') }}</span>
        <br />
        <h5>
          {{
            tripsBetweenGeofences.avg.tripDuration > 0
              ? Math.floor(tripsBetweenGeofences.avg.tripDuration / 3600)
              : Math.ceil(tripsBetweenGeofences.avg.tripDuration / 3600)
          }}
        </h5>
        <strong>{{ $t('global.time.hour') }}</strong>
        <h5>
          {{ Math.floor(Math.abs(Math.round(tripsBetweenGeofences.avg.tripDuration % 3600) / 60)) }}
        </h5>
        <strong>{{ $t('global.time.minutes') }}</strong>
        <h5>
          {{ Math.abs(Math.round(tripsBetweenGeofences.avg.tripDuration % 3600) % 60) }}
        </h5>
        <strong>{{ $t('global.time.seconds') }}</strong>
        <McBadge
          variant="outlineDanger"
          type="button"
          :text="tripsBetweenGeofences.anomaly.tripDuration + $t('report.text.anomalyData')"
          v-if="tripsBetweenGeofences.anomaly.tripDuration"
        />
      </div>
    </b-col>
    <b-col md="6">
      <div class="mc-report__route-geolocation-value-item">
        <span>{{ $t('report.fields.avgSpeed') }}</span>
        <br />
        <h5>
          {{ parseFloat(tripsBetweenGeofences.avg.speed).toFixed(2) ?? '0' }}
          <strong>Km/{{ $t('global.time.hours') }}</strong>
        </h5>
        <McBadge
          variant="outlineDanger"
          type="button"
          :text="tripsBetweenGeofences.anomaly.speed + $t('report.text.anomalyData')"
          v-if="tripsBetweenGeofences.anomaly.speed"
        />
      </div>
    </b-col>
  </b-row>
</template>
<script>
import McBadge from '@/components/McBadge'

export default {
  components: {
    McBadge,
  },

  props: ['tripsBetweenGeofences'],

  methods: {
    secondsToHours(num) {
      const h = num > 0 ? Math.floor(num / 3600) : Math.ceil(num / 3600)
      const m = Math.floor(Math.abs(Math.round(num % 3600) / 60))
      const s = Math.abs(Math.round(num % 3600) % 60)

      if (h != 0) {
        return `<h5>${h}</h5> <strong>${this.$t('global.time.hour')}</strong> ${
          m > 0 ? m + ' ' + this.$t('global.time.minutes') : ''
        } ${s > 0 ? s + ' ' + this.$t('global.time.seconds') : ''}`
      } else {
        if (m != 0) {
          return `${m > 0 ? m + ' ' + this.$t('global.time.minutes') : ''} ${
            s > 0 ? s + ' ' + this.$t('global.time.seconds') : ''
          }`
        } else {
          if (s != 0) {
            return `${s > 0 ? s + ' ' + this.$t('global.time.seconds') : ''}`
          } else {
            return '-'
          }
        }
      }
    },
  },
}
</script>

<style scoped>
h5 {
  display: inline-block;
  margin-right: 0.23rem !important;
}

strong {
  margin-right: 0.23rem !important;
}
</style>
